import { ObjectTypes } from '@fi-shared/types/object-type';
import { FiTagsListPositionTypes, FiTagsSelectionTypes, FiTagsSortType } from './enums';
import { BehaviorSubject } from 'rxjs';
import { ModuleType } from '@fi-shared/types/module-type';
import { comparator } from '@fi-shared/utils/array-sort-comparators';
import { ILightWeightObject } from '@fi-shared/models';
import { IListViewTag } from '@fi-shared/fi-items-list/fi-items-list';
import { isDefined } from '@fi-shared/utils';
import { ILightWeightTag } from '@fi-shared/fi-tag2/fi-tag2';

export interface IListViewSettingModel {
    Id: number;
    ObjectType: ObjectTypes;
    PositionType: FiTagsListPositionTypes;
    ListType: FiTagsSelectionTypes;
    SortType: FiTagsSortType;
    SiteDesignId: number;
    ListViewTags: IListViewTag;
}

export class ListViewSettingModel {
    Id = 0;
    ObjectType = ObjectTypes.Document;
    PositionType: FiTagsListPositionTypes = FiTagsListPositionTypes.Left;
    ListType: FiTagsSelectionTypes = FiTagsSelectionTypes.AllTags;
    SortType: FiTagsSortType = FiTagsSortType.Alphabetical;
    ListViewTags: IListViewTag[] = [];

    textId;
    ModuleType: ModuleType;
    TagsDataSource;
    SiteDesignId: number;

    constructor(setting?: IListViewSettingModel) {
        if (isDefined(setting)) {
            this.Id = setting.Id;
            this.ObjectType = setting.ObjectType;
            this.PositionType = setting.PositionType;
            this.ListType = setting.ListType;
            this.SortType = setting.SortType;
            this.SiteDesignId = setting.SiteDesignId;

            if (setting.ListViewTags && Array.isArray(setting.ListViewTags)) {
                setting.ListViewTags.forEach((tag) => {
                    this.ListViewTags.push({
                        Id: tag.TagId,
                        Name: tag.Name || 'tag ' + tag.TagId,
                        SortOrder: tag.SortOrder,
                    });
                });
                this.sortTags();
            }
        }
    }

    tagsLoaded$ = new BehaviorSubject(false);
    prepareTagsForList(getTagsFunc: () => Promise<ILightWeightTag[]>) {
        const promise = getTagsFunc();
        promise.then((data) => {
            if (this.ListType == FiTagsSelectionTypes.AllTags) {
                this.ListViewTags = data.map((tag, idx) => {
                    const result: IListViewTag = {
                        Id: tag.Id,
                        Name: tag.Name,
                        SortOrder: idx,
                        Level: tag.Level,
                        ParentId: tag.ParentId,
                        IsDisabled: tag.IsDisabled,
                    };
                    return result;
                });
            } else {
                this.excludeUnavailableTags(data);
            }
            this.sortTags();
            setTimeout(() => this.tagsLoaded$.next(true));
        });
        return promise;
    }

    excludeUnavailableTags(availableTags: ILightWeightTag[]) {
        const tempTags = [];
        this.ListViewTags.forEach((tag) => {
            if (availableTags.filter((availableTag) => availableTag.Id === tag.Id).length) tempTags.push(tag);
        });

        this.ListViewTags = tempTags;
    }

    getOrderBy() {
        if (this.ListType === FiTagsSelectionTypes.AllTags) return 'Name';

        return this.SortType === FiTagsSortType.Alphabetical ? 'Name' : 'SortOrder';
    }

    sortTags() {
        const sortProperty = this.getOrderBy();
        this.ListViewTags = this.ListViewTags.sort(
            comparator((item) => {
                let value = item[sortProperty];
                //https://chainformation.atlassian.net/browse/FI-3731
                if (typeof value == typeof '') value = value.toLowerCase();

                return value;
            }),
        );
    }
}

export class ListViewTag implements IListViewTag {
    Id = 0;
    TagId = 0;
    Name = '';
    SortOrder = 0;

    InitWithObjectTag(objectTag: IListViewTag) {
        if (isDefined(objectTag)) {
            this.TagId = objectTag.Id;

            return this;
        }
    }
}
